import * as React from 'react'
import { ChevronDown } from '../../icons'
import { cn } from '../../lib/cn'

/**
 * The escape hatch to a real `<select>`, and the reason it is not `ChipSelect`:
 * it keeps native option groups and the browser's own form validation, which a
 * model catalogue of several hundred entries depends on. Everything else that
 * picks one of N is `ChipSelect` or `Combobox`.
 *
 * Chrome matches {@link Input} — same border, same ground, same radius — so a
 * select and a text field on one row are the same object at a glance.
 */
const NativeSelect = React.forwardRef<
  HTMLSelectElement,
  React.SelectHTMLAttributes<HTMLSelectElement>
>(({ className, ...props }, ref) => (
  <div className='relative min-w-0'>
    <select
      ref={ref}
      className={cn(
        'flex w-full min-w-0 touch-manipulation appearance-none rounded-sm border border-[var(--border)] bg-[var(--surface-5)] py-1.5 pr-7 pl-2 font-sans text-sm text-[var(--text-primary)] transition-colors outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    />
    <ChevronDown
      aria-hidden
      className='pointer-events-none absolute top-1/2 right-2 size-[14px] -translate-y-1/2 text-[var(--text-icon)]'
    />
  </div>
))
NativeSelect.displayName = 'NativeSelect'

export { NativeSelect }
